import $ from 'jquery';

export default function int_menu() {
	var height_mega_dropdown = calculateHeightMegaDropdown();
	var height_dd_grid = calculateHeightDdGrid();
	if (window.innerWidth > 768) {
		$(document).mouseup(function (e) {
			if(!$(".mega-dropdown.open").is(e.target) && !$(".mnav-item").is(e.target)){
				//$(".mega-dropdown.open").removeClass('open');
				//$(".mnav-item.open").removeClass("open");
			}
		});
	}

	function calculateHeightMegaDropdown() {
		return window.innerHeight - 60;
	}

	function calculateHeightDdGrid() {
		return window.innerHeight - 222;
	}
	
	if (window.innerWidth <= 768) {
		$(".mega-dropdown").css({ minHeight: height_mega_dropdown + "px" });
		$(".mega-dropdown .dd-grid").css({ maxHeight: height_dd_grid + "px" });
	}
	$(".mnav-item").click(function (e) {
		e.preventDefault();
		let that = $(this);
		$(".elements-search").removeClass("is-open");
		$(".mega-dropdown.open").removeClass("open");
		$(".mob-en-link").hide()
		if (that.hasClass("open")) {
			that.removeClass("open");
		} else {
			$(".mnav-item.open").removeClass("open");
			that.addClass("open");
			that.closest("li").find("> .mega-dropdown").addClass("open");
		}

	});
	
	$(".dd-title").click(function (e) {
		e.preventDefault();
		let that = $(this);
		$(".dd-submenu.open").removeClass("open");
		$(".mega-dropdown .dd-grid").toggleClass('dropdown-open');

		if (that.hasClass("back-action")) {
			$(".mnav-item.open").removeClass("open");
			$(".mega-dropdown.open").removeClass("open");
			$(".mob-en-link").show()
		} else {
			if (that.hasClass("open")) {
				that.removeClass("open");
				$('.mobile-nav-footer').removeClass('hide');
			} else {

				$(".dd-title").removeClass("open");
				that.addClass("open");
				that.parent().next(".dd-submenu").addClass("open");
				$('.mobile-nav-footer').addClass('hide');
			}
		}

	});
	$(".main-nav-wrap .hamburger").click(function (e) {
		e.preventDefault();
		let that = $(this);
		if (that.hasClass("active")) {
			that.removeClass("active");
			$(".main-nav-container").removeClass("open").css({ minHeight: "" });
			$("html").removeClass("menu-open");
			$(".elements-alert-banner.is-closed").removeClass("is-closed")
		} else {
			that.addClass("active");
			$(".main-nav-container").addClass("open");
			if (window.innerWidth <= 768) {
				$(".elements-alert-banner.is-open").addClass("is-closed")
				$(".main-nav-container").css({ minHeight: height_mega_dropdown + "px" }); 
			}
			$("html").addClass("menu-open");
		}

	})
	$(".main-nav-wrap .search").click(function (e) {
		e.preventDefault();
		$(".elements-search").toggleClass("is-open");
		$(".mega-dropdown.open").removeClass("open");
		$("html").removeClass("menu-open");
		$(".mnav-item.open").removeClass("open");
	})

	$("#skip-to-content-link").click(function (e) {
		e.preventDefault();
		$(".cai-wrapper-modules :focusable:first").focus();

	});

	(function ($) {
		function visible(element) {
			return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function () {
				return $.css(this, 'visibility') === 'hidden';
			}).length;
		}

		function focusable(element, isTabIndexNotNaN) {
			var map, mapName, img, nodeName = element.nodeName.toLowerCase();
			if ('area' === nodeName) {
				map = element.parentNode;
				mapName = map.name;
				if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
					return false;
				}
				img = $('img[usemap=#' + mapName + ']')[0];
				return !!img && visible(img);
			}
			return (/input|select|textarea|button|object/.test(nodeName) ?
				!element.disabled :
				'a' === nodeName ?
					element.href || isTabIndexNotNaN :
					isTabIndexNotNaN) &&
				// the element and all of its ancestors must be visible
				visible(element);
		}

		$.extend($.expr[':'], {
			focusable: function (element) {
				return focusable(element, !isNaN($.attr(element, 'tabindex')));
			}
		});
	})($);
	
	$(document).click(function(event) { 
		if(!$(event.target).closest('.main-navigation , .main-navigation *').length 
		&& !$(event.target).is('.main-nav-wrap .search') 
		&& !$(event.target).is('.main-nav-wrap *')
		&& !$(event.target).is('.breadcrumb-item.second *')) {
			$(".mega-dropdown.open").removeClass("open");
			$("html").removeClass("menu-open");
			$(".mnav-item.open").removeClass("open");
			$(".main-nav-container").removeClass("open")
			$(".main-nav-wrap .hamburger").removeClass("active")
			$(".main-nav-container").removeClass("open").css({ minHeight: "" });
		}        
	});
}


